import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useGlobalContext } from "../context";

const url = process.env.REACT_APP_API_URL + "/orders";
// const url = "https://ekart-express-api.herokuapp.com/api/v1/orders";

function PlaceOrder() {
  const [paymentMode, setPaymentMode] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const { cartItems, setCartItems, setCartCount } = useGlobalContext();
  const [orderPlaced, setOrderPlaced] = useState(false);
  const location = useLocation();

  /**
   * @desc Fetch cart items and total amount
   */
  const fetchCartItems = async () => {
    const cartUrl = process.env.REACT_APP_API_URL + "/cart";

    if (JSON.parse(localStorage.getItem("ekartToken"))) {
      const response = await axios.get(cartUrl, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("ekartToken")).token,
        },
      });

      setCartItems(response.data.items);
      setCartCount(response.data.items.length);

      const totalPrice = response.data.items.reduce((acc, curr) => {
        acc += curr.total;
        return acc;
      }, 0);

      setTotalAmount(totalPrice);
    }
  };

  useEffect(() => {
    fetchCartItems();
  }, []);

  /**
   * @desc Get payment mode
   * @param {*} e
   */
  const handleChange = async (e) => {
    const paymentMode = e.target.id;

    if (paymentMode === "pay-cod") {
      setPaymentMode("cod");
    } else {
      setPaymentMode("online");
    }
  };

  /**
   * @desc Place order based on payment mode
   * @param {*}
   */
  const placeOrder = async () => {
    // Oder confirmation for COD
    if (paymentMode === "cod") {
      const order = {
        name: location.state.name,
        mobile: location.state.mobile,
        address: location.state.address,
        pincode: location.state.pincode,
        landMark: location.state.landMark,
        orderDetails: cartItems,
        totalAmount: totalAmount,
        total: totalAmount,
        paymentMode: "cod",
        isPaid: false,
        items: cartItems,
        ...location.state,
      };

      setCartCount(0);
      setCartItems([]);

      await axios.post(`${url}`, order, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("ekartToken")).token,
        },
        params: {
          cartId: JSON.parse(localStorage.getItem("ekartToken")).cartId,
        },
      });

      setCartCount(0);
      fetchCartItems();
      setOrderPlaced(true);
    } else {
      // Oder confirmation for Online payment
      const order = {
        name: location.state.name,
        mobile: location.state.mobile,
        address: location.state.address,
        pincode: location.state.pincode,
        landMark: location.state.landMark,
        totalAmount: totalAmount,
        paymentMode: "online",
        isPaid: false,
        orderDetails: cartItems,
      };

      loadRazorpay(order);
    }
  };

  /**
   * @desc Load razorpay script for payment
   */
  function loadRazorpay(order) {
    console.log("ORDER OBJ: ", order);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onerror = () => {
      alert("Razorpay SDK failed to load. Are you online?");
    };
    script.onload = async () => {
      try {
        // Create order
        order.totalAmount += "00";
        const result = await axios.post(`${url}/create-order`, order, {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("ekartToken")).token,
          },
        });
        const { amount, id: order_id, currency } = result.data.order;

        // Get razorpay key
        const response = await axios.get(`${url}/get-razorpay-key`, {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("ekartToken")).token,
          },
        });
        const razorPayKey = response.data.key;

        const options = {
          key: razorPayKey,
          amount: amount.toString(),
          currency: currency,
          name: "Groxeries",
          description: "Online Transaction",
          order_id: order_id,
          handler: async function (response) {
            // Place the order
            const result = await axios.post(
              `${url}/pay-order`,
              {
                name: order.name,
                mobile: order.mobile,
                address: order.address,
                pincode: order.pincode,
                landMark: order.landMark,
                paymentMode: order.paymentMode,
                totalAmount: order.totalAmount,
                orderDetails: order.orderDetails,
                amount: amount,
                razorpayPaymentId: response.razorpay_payment_id,
                razorpayOrderId: response.razorpay_order_id,
                razorpaySignature: response.razorpay_signature,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " +
                    JSON.parse(localStorage.getItem("ekartToken")).token,
                },
                params: {
                  cartId: JSON.parse(localStorage.getItem("ekartToken")).cartId,
                },
              }
            );
            alert(result.data.msg);
            setCartCount(0);
            fetchCartItems();
            setOrderPlaced(true);
          },
          prefill: {
            name: "Groxeries",
            email: "groxeries@shopping.com",
            contact: "8956764442",
          },
          notes: {
            address: "Bhugaon Wardha",
          },
          theme: {
            color: "#80c0f0",
          },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      } catch (err) {
        console.log("Something went wrong!");
      }
    };

    document.body.appendChild(script);
  }

  return (
    <div
      className="d-flex justify-content-center flex-wrap"
      style={{ marginTop: "5.5rem" }}
    >
      <form
        className="border border-primary d-flex justify-content-between flex-column"
        style={{
          margin: "2rem",
          border: "1px solid lightgray",
          padding: "2rem",
          borderRadius: "1rem",
          width: "30rem",
        }}
      >
        <div
          style={{ height: "4.5rem" }}
          className="d-flex justify-content-between flex-column"
        >
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="payment"
              id="pay-cod"
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="pay-cod">
              Cash On Delivery
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="payment"
              id="pay-online"
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="pay-online">
              Online Payment{" "}
              <small style={{ color: "gray" }}>(Razor Pay)</small>
            </label>
          </div>
        </div>
        <div>
          {orderPlaced ? (
            <div className="d-flex justify-content-center flex-column align-items-center">
              <div
                className="mt-3 d-grid gap-2 alert alert-success"
                role="alert"
                style={{ width: "80%", textAlign: "center" }}
              >
                Order Placed Successfully
                <br />
              </div>
              <button
                className="btn btn-success"
                type="button"
                style={{ width: "80%" }}
              >
                <Link style={{ textDecoration: "none", color: "#fff" }} to="/">
                  Back to Shopping
                </Link>
              </button>
            </div>
          ) : (
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-success"
                type="button"
                style={{ width: "80%", marginTop: "2rem" }}
                onClick={placeOrder}
                disabled={orderPlaced}
              >
                <Link
                  style={{ textDecoration: "none", color: "#fff" }}
                  to="/place-order"
                >
                  Place Order
                </Link>
              </button>
            </div>
          )}
        </div>
      </form>
      <div
        style={{
          margin: "2rem",
          border: "1px solid lightgray",
          padding: "2rem",
          borderRadius: "1rem",
          height: "13rem",
        }}
      >
        <div>
          <span className="fw-bold">Delivery Charges:</span> ₹ 50
        </div>
        <hr />
        <div>
          <p className="fs-5 fw-bolder text-danger">
            Order Total: ₹ {totalAmount}
          </p>
        </div>
        <hr />
        <div className="fs-6 text-muted">
          NOTE: COD, card and UPI payments are supported!
        </div>
      </div>
    </div>
  );
}

export default PlaceOrder;
